/** Load persisted column keys from localStorage (filtered to only allowed keys) */
export const loadStorageKeys = (key: string, allowedKeys: string[]) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    const keys: string[] = Array.isArray(parsed?.keys) ? parsed.keys : [];
    return keys.filter((k) => allowedKeys.includes(k));
  } catch {
    return [];
  }
};

/** Persist selected column keys */
export const saveStorageKeys = (key: string, keys: string[]) => {
  try {
    localStorage.setItem(key, JSON.stringify({ keys, v: 1 }));
  } catch {
    /* ignore */
  }
};

/** Remove persisted column selection */
export const removeStorageKeys = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
};
